import { el } from '../lib/dom.js';

const LABELS = {
  hp: 'HP',
  attack: 'Atk',
  defense: 'Def',
  'special-attack': 'SpA',
  'special-defense': 'SpD',
  speed: 'Spe',
};

// 255 is the max any base stat reaches (Blissey HP).
export function StatBar(name, value) {
  const pct = Math.min(100, (value / 255) * 100);
  return el(
    'div',
    { class: 'statbar' },
    el('span', { class: 'statbar__label' }, LABELS[name] || name),
    el('span', { class: 'statbar__value' }, String(value)),
    el(
      'div',
      { class: 'statbar__track' },
      el('div', {
        class: 'statbar__fill',
        dataset: { stat: name },
        style: `width:${pct}%`,
      }),
    ),
  );
}
